import TheFooter from './TheFooter.vue';
export { TheFooter };
export default TheFooter;